import React from 'react';

import { useFormContext, useWatch } from 'react-hook-form';

import { useTemplateStudioState } from 'state/hooks/template-studio.hook';
import { z } from 'zod';

import { FormControl, FormField, FormItem, FormMessage } from 'components/ui';

import { templateStudioSchema } from '../../../validation-schema';
import { TemplateStudioOfferPerRowSelect } from '../Components/OfferPerRowSelect';
import { ThemesFormItem } from '../Components/ThemesFormItem';

export const TemplateStudioBundleForm: React.FC = () => {
  const { control } = useFormContext<z.infer<typeof templateStudioSchema>>();
  const { supportedThemesForBundles } = useTemplateStudioState();
  const bundle = useWatch({ control, name: 'bundle' });

  if (!supportedThemesForBundles) return null;

  return (
    <>
      <FormField
        control={control}
        name="bundle.themes"
        render={({ field }) => (
          <ThemesFormItem
            onChange={field.onChange}
            value={field.value || []}
            supportedThemes={supportedThemesForBundles}
            themesSelectDataTestId="TemplatesStudio-Bundle-themes"
          />
        )}
      />
      <FormField
        control={control}
        name="bundle.offersPerRow"
        render={({ field }) => (
          <FormItem>
            <FormControl>
              <TemplateStudioOfferPerRowSelect
                value={field.value}
                onChange={field.onChange}
                bundleViewModel={bundle?.bundleViewModel}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
};
